import { makeStyles } from '@material-ui/core/styles';

const VALUE_COLUMN_WIDTH = 200;

export default makeStyles((theme) => ({
  modal: {
    width: 720,
    '& .MuiDialogContent-root': {
      padding: theme.spacing(12)
    }
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    width: '100%'
  },
  question: {
    marginTop: theme.spacing(4)
  },
  title: {
    fontSize: 40,
    color: theme.colorPalette.green_75
  },
  divider: {
    width: '100%',
    margin: 0
  },
  option: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(4),
    padding: theme.spacing(2, 0)
  },
  radio: {
    color: theme.colorPalette.green_75,
    '&.Mui-checked': {
      color: theme.colorPalette.orange_50
    }
  },
  calculatedValue: {
    width: VALUE_COLUMN_WIDTH,
    paddingLeft: theme.spacing(2),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  agentField: {
    width: VALUE_COLUMN_WIDTH
  },
  note: {
    minHeight: 'unset',
    margin: theme.spacing(0, 0, 2),
    textAlign: 'start'
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(3)
  },
  action: {
    padding: theme.spacing(1.5, 4)
  }
}));
